import React, { useCallback } from 'react';
import { Flex, FlexItem, Button, LabelGroup, Label } from '@patternfly/react-core';
import useBoolean from 'utils/hooks/useBoolean';
import ModelContentSelectorModal from 'components/SignalSelector/ModelContentSelectorModal';
import ComponentPropTypes from './ComponentPropTypes';
import { useTranslation } from 'localization/useTranslation';
import { ContentType } from 'utils/dtdl';

const SignalsComponent = ({ model, value, onChange, isProperty }) => {
  const [isSignalSelectorOpen, openSignalSelector, closeSignalSelector] = useBoolean(false);
  const T = useTranslation();

  const _onChange = useCallback(newValue => {
    onChange(model, newValue);
    closeSignalSelector();
  }, [closeSignalSelector, model, onChange]);

  return (
    <>
      <Flex>
        <FlexItem>
          <Button onClick={openSignalSelector}>{ isProperty ? T.modals.selectproperties.title : T.modals.selectsignals.title }</Button>
        </FlexItem>
        <FlexItem>
          <LabelGroup
            onClick={() => {}}
            numLabels={2}
          >
            { value?.map((item, index) => (
              <Label key={index}
                variant="outline"
                color="blue"
              >
                { item.displayName }
              </Label>
            )) }
          </LabelGroup>
        </FlexItem>
      </Flex>
      <ModelContentSelectorModal
        selectedItems={value}
        isOpen={isSignalSelectorOpen}
        onConfirm={_onChange}
        onCancel={closeSignalSelector}
        contentType={isProperty ? ContentType.PROPERTIES : ContentType.TELEMETRY}
      />
    </>);
};

SignalsComponent.propTypes = ComponentPropTypes;

export default React.memo(SignalsComponent);
